export const deClientPortalAssetListPage = {
    emptyStateTitle: 'Noch keine Immobilien hinterlegt',
    syntheticPortfolioTitle: 'Immobilien ohne Portfolio',
    closingDateLabel: 'Stichtag {{date}}',
}
